// /src/pages/InvestorsPage/Investorindex.jsx
import React from 'react';
import InvestorFloatingButtons from './InvestorFloatingButtons';
import InvestorHeader from './InvestorHeader';
import InvestorsHero from './InvestorsHero';
import FounderVision from './FounderVision';
import ProblemBlock from './ProblemBlock';
import SolutionOverview from './SolutionOverview';
import WhyNow from './WhyNow';
import MarketOpportunity from './MarketOpportunity';
import BusinessModel from './BusinessModel';
import Traction from './Traction';
import Roadmap from './Roadmap';
import TeamIntro from './TeamIntro';
import InvestmentDetails from './InvestmentDetails';
import LegalStructure from './LegalStructure';
import InvestorCTA from './InvestorCTA';
import Footer from './Footer';

export default function Investorindex() {
  return (
    <div className="w-full bg-black text-white">
      <InvestorFloatingButtons />
      <InvestorHeader />
      <InvestorsHero />
      <FounderVision />
      <ProblemBlock />
      <SolutionOverview />
      <WhyNow />
      <MarketOpportunity />
      <BusinessModel />
      <Traction />
      <Roadmap />
      <TeamIntro />    
      <InvestmentDetails />
      <LegalStructure />
      <InvestorCTA />
      <Footer />

    </div>
  );
}
